import React, { useState, useEffect } from 'react';
import {useParams } from 'react-router-dom';
import PropertyBox from '../home/propertyBox';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { FiShare2, FiCopy } from "react-icons/fi";
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { MdWhatsapp } from "react-icons/md";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Helmet} from "react-helmet";


import properyImg1 from '../../../assets/images/property/img1.jpg'
import properyImg2 from '../../../assets/images/property/img2.jpg'
import properyImg3 from '../../../assets/images/property/img3.jpg'
import properyImg4 from '../../../assets/images/property/img4.jpg'
import properyImg5 from '../../../assets/images/property/img5.jpg'
import properyImg6 from '../../../assets/images/property/img6.jpg'
import properyImg7 from '../../../assets/images/property/img7.jpg'
import properyImg8 from '../../../assets/images/property/img8.jpg'
import emptyVideo from '../../../assets/images/empty.mp4'
import kpLogo from '../../../assets/images/kplot-logo.png'
import axios from 'axios';
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';

const path = "/keralaplots/";


function InnerAgents() {
    const {id } = useParams();
    // skelly loader
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true)
    const BASE_URL = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/";
    const BASE_URL_NOIMG = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/nophoto.webp";

    useEffect(() => {
        fetchAgentdetailsid(0);
    }, []);

    
    useEffect(() => {
        if (page !== 0) fetchAgentdetailsid(page); // Fetch more data when page changes
    }, [page]); // Depend on page change

    const [agentdetails,setagentdetails]=useState([]);
    const [Properties,setProperties]=useState([]);
    const [firstLeter,setfirstLeter]=useState();
    const fetchAgentdetailsid=async(pageNumber = page)=>{
        try {
            const response=await axios.post(`${baseURL}/fetchAgentdetailsid`,{
                id: id, // Send ID in request body (not params)
                offset: pageNumber, // Pagination offset
                limit: 24
            })
            console.log(response.data)
            const agentdetails=response.data.userdetails[0]
            const propertydetails=response.data.propertydetails
            setagentdetails(agentdetails)
            setfirstLeter(agentdetails.fullname.charAt(0))
            setProperties(propertydetails)
            if (propertydetails && propertydetails.length > 0) {
                setProperties((prevData) => (pageNumber === 0 ? propertydetails : [...prevData, ...propertydetails])); // Append or reset data
                console.log("length "+propertydetails.length)
                setHasMore(propertydetails.length === 24);
                setIsLoading(false);
                 // If less than 24 results, hide Load More button
            } else {
                setHasMore(false);
                setIsLoading(false);
            }
        } catch (error) {
            
        }
    }

    const handleLoadMore = () => {
        const nextPage = page + 24;
        setPage(nextPage);
    };

    const agentName = "Levi";

    // handleCopy
    const handleCopy = () => {
        const content = `Agent: ${agentdetails.fullname}\n${window.location.href}`;
        navigator.clipboard.writeText(content);
        toast.success(`Copied: ${content}`);
    }

    // handleShareWhatsapp
    const handleShareWhatsapp = () => {
        const content = `Agent: ${agentdetails.fullname}\n${window.location.href}`;
        const url = `whatsapp://send?text=${encodeURIComponent(content)}`;
        window && window.open(url, '_blank');
    }

  return (
    <>
        <Tooltip id="my-tooltip" />
        <Helmet>
            <meta property="og:image" content={kpLogo} />
        </Helmet>

        {/* <section id="innerAgents">
            <div className="innerAgentsProfile">
                <div className="container">
                    <div className="innerAgentsProfileCol1">
                        <div className="innerAgentsProfileBox1">
                            <div className="innerAgentsProfileThumbnail">
                                <h4>{firstLeter}</h4>
                            </div>
                            <div className="innerAgentsProfileDetails">
                                <h3 className="agentName">{agentdetails.fullname}</h3>
                                <div className="agentLocation">{agentdetails.town}</div>
                            </div>
                        </div>
                        <div className="innerAgentsProfileBox2">
                            <div className="agentShareBtn" data-tooltip-id="my-tooltip" data-tooltip-content="Share">
                                <FiShare2 />
                                <div className="agentSharePopup">
                                    <ul>
                                        <li className='copyLink' onClick={handleCopy}>
                                            <div className="icon">
                                                <FiCopy />
                                            </div>
                                            <p>Copy Link</p>
                                        </li>
                                        <li className='shareWhatsapp' onClick={handleShareWhatsapp}>
                                            <div className="icon">
                                                <MdWhatsapp />
                                            </div>
                                            <p>Share Whatsapp</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <a href="tel:+919876543210">Contact Now</a>
                        </div>
                    </div>
                    <div className="innerAgentsProfileCol2">
                        <ul>
                            <li>
                                <h2>{agentdetails.experiance_val}</h2>
                                <p>Experience</p>
                            </li>
                            <li>
                                <h2>{agentdetails.total_properties}</h2>
                                <p>Properties</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="innerAgentsMain">
                    <div className="innerAgentsPropertyList">
                        {isLoading ? (
                            <div className='SkeletonLoader'>
                            <div className='SkeletonLoaderBox'>
                                <div className="SkeletonLoaderBoxCol1">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2">
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                </div>
                            </div>
                            <div className='SkeletonLoaderBox'>
                                <div className="SkeletonLoaderBoxCol1">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2">
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                </div>
                            </div>
                            <div className='SkeletonLoaderBox'>
                                <div className="SkeletonLoaderBoxCol1">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2">
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                </div>
                            </div>
                            <div className='SkeletonLoaderBox'>
                                <div className="SkeletonLoaderBoxCol1">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2">
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                </div>
                            </div>
                            <div className='SkeletonLoaderBox'>
                                <div className="SkeletonLoaderBoxCol1">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2">
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                </div>
                            </div>
                            <div className='SkeletonLoaderBox'>
                                <div className="SkeletonLoaderBoxCol1">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2">
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                </div>
                            </div>
                            <div className='SkeletonLoaderBox'>
                                <div className="SkeletonLoaderBoxCol1">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2">
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                </div>
                            </div>
                            <div className='SkeletonLoaderBox'>
                                <div className="SkeletonLoaderBoxCol1">
                                    <Skeleton />
                                </div>
                                <div className="SkeletonLoaderBoxCol2">
                                  <Skeleton />
                                  <Skeleton />
                                  <Skeleton />
                                </div>
                            </div>
                        </div>
                        ) : (
                            <>
                                {Properties.map((allPropertie) => {
                                    return (
                                    <PropertyBox 
                                    propertyLink={`${path}innerProperty/${allPropertie.propertyId}/${allPropertie.propertyType.replace('/', '')+" for "+allPropertie.propertyAction}`}
                                    propertyImage={allPropertie.imageName ? "https://keralaplots.com/assets/images/PropertyImage/"+allPropertie.imageName : BASE_URL_NOIMG} 
                                    propertyPurposeTag={allPropertie.propertyAction} 
                                    propertyId={allPropertie.propertyId}
                                    propertyName={allPropertie.propertyType+" For "+allPropertie.propertyAction} 
                                    propertyLocation={allPropertie.district +' , '+ allPropertie.town}
                                    propertyDate={allPropertie.addedDate}
                                    propertyPrice={allPropertie.priceVisibility === 'no' ? 'Not disclosed' : allPropertie.propertyPricerange} 
                                    propertyType={allPropertie.propertyType}
                                    propertySeen={false}
                                    propertyContacted={false}
                                    />
                                 )
                                })}
                            </>
                        )}
                    </div>
                    {hasMore && (
                    <div className="loadMoreArea">
                        <button
                            className="loadMoreBtn"
                            onClick={handleLoadMore}
                            disabled={isLoading}
                        >
                            {isLoading ? "Loading..." : "Load More"}
                        </button>
                        
                    </div>
                        )}
                </div>
                <div className="emptyPage" style={{ display: Properties.length === 0 && !isLoading ? 'block' : 'none' }}>
                  <div className="container">
                    <div className="emptyPageMain">
                      <div className="emptyPageBoxThumbnail">
                        <video
                            playsInline
                            preload="auto"
                            autoPlay
                            muted
                            loop
                        >
                            <source src={emptyVideo} type="video/mp4" />
                        </video>
                      </div>
                      <div className="emptyPageBoxDetails">
                        <h2 className="title">Properties not available</h2>
                        <p>Properties are currently unavailable. Please leave a message or check back later. We appreciate your patience and will respond as soon as possible.</p>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </section> */}

        <section id="innerAgents">
            <div className="innerAgentsProfile">
                <div className="container">
                    <div className="innerAgentsProfileCol1">
                        <div className="innerAgentsProfileBox1">
                            <div className="innerAgentsProfileThumbnail">
                                <h4>{firstLeter}</h4>
                            </div>
                            <div className="innerAgentsProfileDetails">
                                <h3 className="agentName">{agentdetails.fullname}</h3>
                                <div className="agentLocation">{agentdetails.town}</div>
                            </div>
                        </div>
                        <div className="innerAgentsProfileBox2">
                            <div className="agentShareBtn" data-tooltip-id="my-tooltip" data-tooltip-content="Share">
                                <FiShare2 />
                                <div className="agentSharePopup">
                                    <ul>
                                        <li className='copyLink' onClick={handleCopy}>
                                            <div className="icon">
                                                <FiCopy />
                                            </div>
                                            <p>Copy Link</p>
                                        </li>
                                        <li className='shareWhatsapp' onClick={handleShareWhatsapp}>
                                            <div className="icon">
                                                <MdWhatsapp />
                                            </div>
                                            <p>Share Whatsapp</p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <a href="tel:+919876543210">Contact Now</a>
                        </div>
                    </div>
                    <div className="innerAgentsProfileCol2">
                        <ul>
                            <li>
                                <h2>{agentdetails.experiance_val}</h2>
                                <p>Experience</p>
                            </li>
                            <li>
                                <h2>{agentdetails.total_properties}</h2>
                                <p>Properties</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="innerAgentsMain">
                    <div className="innerAgentsPropertyList">
                        {isLoading ? (
                            <div className='SkeletonLoader'>
                                {[...Array(8)].map((_, index) => (
                                    <div key={index} className='SkeletonLoaderBox'>
                                        <div className="SkeletonLoaderBoxCol1">
                                            <Skeleton />
                                        </div>
                                        <div className="SkeletonLoaderBoxCol2">
                                            <Skeleton />
                                            <Skeleton />
                                            <Skeleton />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            Properties.map((allPropertie) => (
                                <PropertyBox 
                                    key={allPropertie.propertyId}
                                    propertyLink={`${path}innerProperty/${allPropertie.propertyId}/${allPropertie.propertyType.replace('/', '') + " for " + allPropertie.propertyAction}`}
                                    propertyImage={allPropertie.imageName ? `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/${allPropertie.imageName}` : BASE_URL_NOIMG}
                                    propertyPurposeTag={allPropertie.propertyAction}
                                    propertyId={allPropertie.propertyId}
                                    propertyName={`${allPropertie.propertyType} For ${allPropertie.propertyAction}`}
                                    propertyLocation={`${allPropertie.district} , ${allPropertie.town}`}
                                    propertyDate={allPropertie.addedDate}
                                    propertyPrice={allPropertie.priceVisibility === 'no' ? 'Not disclosed' : allPropertie.propertyPricerange}
                                    propertyType={allPropertie.propertyType}
                                    propertySeen={false}
                                    propertyContacted={false}
                                    addedId={allPropertie.loginId}
                                />
                            ))
                        )}
                    </div>
                    {hasMore && (
                        <div className="loadMoreArea">
                            <button className="loadMoreBtn" onClick={handleLoadMore} disabled={isLoading}>
                                {isLoading ? "Loading..." : "Load More"}
                            </button>
                        </div>
                    )}
                </div>
                {Properties.length === 0 && !isLoading && (
                    <div className="emptyPage">
                        <div className="container">
                            <div className="emptyPageMain">
                                <div className="emptyPageBoxThumbnail">
                                    <video playsInline preload="auto" autoPlay muted loop>
                                        <source src={emptyVideo} type="video/mp4" />
                                    </video>
                                </div>
                                <div className="emptyPageBoxDetails">
                                    <h2 className="title">Properties not available</h2>
                                    <p>Properties are currently unavailable. Please leave a message or check back later. We appreciate your patience and will respond as soon as possible.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>

    </>
  );
}

export default InnerAgents;
